{
  "forgot_password": "Forgot Password",
  "subHeader": "Enter your e-mail below to receive a link to reset your password",
  "valueShouldBeAnEmail": "Invalid value for the filed, it should be a valid E-mail",
  "reset": "Send reset link",
  "email_send": "We send you an e-mail with further instructions",
  "email": "Email"
}
